import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { Menu } from 'lucide-react';
import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { EsgCycleProvider } from '@/features/esg/components/EsgCycleProvider';
import { EsgCycleToolbar } from '@/features/esg/components/EsgCycleToolbar';
import { EsgMobileNav } from '@/features/esg/components/EsgMobileNav';
import { EsgNav } from '@/features/esg/components/EsgNav';

export const Route = createFileRoute('/_authenticated/esg')({
  beforeLoad: ({ location }) => {
    if (location.pathname === '/esg') {
      // TanStack Router expects redirect to be thrown as control flow.
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/esg/overview' });
    }

    return {
      getTitle: () => 'ESG / CSRD',
    };
  },
  component: EsgLayout,
});

function EsgLayout() {
  return (
    <EsgCycleProvider>
      <EsgLayoutContent />
    </EsgCycleProvider>
  );
}

function EsgLayoutContent() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className="flex min-h-[calc(100vh-4rem)]">
      <EsgNav />
      <EsgMobileNav open={mobileNavOpen} onOpenChange={setMobileNavOpen} />

      <div className="flex-1 overflow-auto">
        <div className="sticky top-0 z-10 flex items-center border-b bg-background px-4 py-2 md:hidden">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => {
              setMobileNavOpen(true);
            }}
            aria-label="ESG / CSRD navigation"
            className="h-11 w-11"
          >
            <Menu className="h-5 w-5" />
          </Button>
          {/* eslint-disable-next-line i18next/no-literal-string */}
          <span className="ml-2 text-sm font-medium text-muted-foreground">ESG / CSRD</span>
        </div>
        <EsgCycleToolbar />
        <Outlet />
      </div>
    </div>
  );
}
